import styled from 'styled-components'
export const StyledErrorBlock = styled.div`
    color: ${props => props.theme.main.colors.errorColor};
    font-size: 13px;
    width: 100%;
    margin-bottom: 24px;
`
